export const PageScreen = {
  dashboard: "/map",
};
